import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=204d8d92&scoped=true"
import script from "./AppError.vue?vue&type=script&lang=js"
export * from "./AppError.vue?vue&type=script&lang=js"
import style0 from "./AppError.vue?vue&type=style&index=0&id=204d8d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d8d92",
  null
  
)

export default component.exports